import { forOwn } from 'lodash-es';

/**
 * Create the URL query based on the parameters.
 *
 * @param params the request parameters as object
 *
 * IMPORTANT
 * Boolean values must be inserted as strings otherwise they removed from query
 *
 * @returns {string} the query url part
 */
var createURLQuery = function createURLQuery(params) {
  var parameters = "";
  params && forOwn(params, function (value, key) {
    if (key) {
      var paramValue = value;
      if (Array.isArray(value)) {
        paramValue = value.length > 0 ? value.map(function (v, i) {
          return i === 0 ? v : key + "=" + v;
        }).join("&") : undefined;
      }
      if (paramValue) {
        parameters += "".concat(parameters.length === 0 ? "?" : "&").concat(key, "=").concat(paramValue);
      }
    }
  });
  return parameters;
};

export { createURLQuery };
//# sourceMappingURL=apiUtil.js.map
